import { FaShippingFast, FaWallet, FaUndo, FaGift } from "react-icons/fa";
import "./Features.css";

function Features() {
  const features = [
    {
      id: 1,
      icon: <FaShippingFast size={50} className="mb-3" />,
      title: "Worldwide Shipping",
      desc: "Lorem ipsum dolor sit amet.",
    },
    {
      id: 2,
      icon: <FaWallet size={50} className="mb-3" />,
      title: "Secure Payment",
      desc: "Lorem ipsum dolor sit amet.",
    },
    {
      id: 3,
      icon: <FaUndo size={50} className="mb-3" />,
      title: "Return/Refund",
      desc: "Lorem ipsum dolor sit amet.",
    },
    {
      id: 4,
      icon: <FaGift size={50} className="mb-3" />,
      title: "Best Gift Voucher",
      desc: "Lorem ipsum dolor sit amet.",
    },
  ];

  return (
    <section className="features container-fluid px-md-5 py-5">
      <div className="row text-center">
        {features.map((feature) => (
          <div key={feature.id} className="col-6 col-md-3 mb-4">
            {feature.icon}
            <h5 className="fw-bold">{feature.title}</h5>
            <p className="text-muted">{feature.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Features;
